import FuxHTTP from "../lib/FuxFramework/FuxHTTP";
import APIConfig from "./APIConfig";
import AuthAPI from "./AuthAPI";

const GoogleCalendarAPI = {
    getCalendars() {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url(`/google-calendar/get-calendars`),
            {token: AuthAPI.getUserAccessToken()},
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },

    deleteCalendar(calendarId) {
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url(`/google-calendar/delete-calendar`),
            {calendar_id: calendarId, token: AuthAPI.getUserAccessToken()},
            FuxHTTP.RESOLVE_MESSAGE,
            FuxHTTP.REJECT_MESSAGE
        );
    },

    setDefaultCalendar(calendarId) {
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url(`/google-calendar/set-default-calendar`),
            {calendar_id: calendarId, token: AuthAPI.getUserAccessToken()},
            FuxHTTP.RESOLVE_MESSAGE,
            FuxHTTP.REJECT_MESSAGE
        );
    },

    getAuthLoginUrl(redirectUrl = null) {
        const params = new URLSearchParams();
        params.append("token", AuthAPI.getUserAccessToken());
        if (redirectUrl) {
            params.append("redirectUrl", redirectUrl);
        }
        return `${APIConfig.url(`/google-calendar/auth-login`)}?${params.toString()}`;
    }
};

export default GoogleCalendarAPI;
